var map = {
	"./admin.js": 901,
	"./auth.js": 9045,
	"./authfack.js": 8564,
	"./insurance.js": 3862,
	"./layout.js": 1708,
	"./notification.js": 102,
	"./organisation.js": 704,
	"./payment.js": 9989,
	"./profile.js": 6967,
	"./upload.js": 6794,
	"./user.js": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2115;